import React, { useState } from 'react';

import styled from 'styled-components';
import { Link } from 'react-router-dom';
import CategoryCard from '../atoms/CategoryCard';
import Btnsearch from '../atoms/btnsearch';
import categories, { getPathByParam } from '../../constants/ProductCategories';
import { useSearchPath } from '../../hooks/useSeachPath';

const Container = styled.div`
  background: #002666;
  color: #fff;
  padding: 0;
  flex: 1;

`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 50px auto;
  form {
    display: flex;
    justify-content: center;
    margin: 0 auto;
    width: 90%;
    font-size: 13px;
    input {
      color: #a3a3a3;
      font-weight: bold;
      width: calc(100% - 150px);
      height: 60px;
      padding-left: 25px;
      border: 0;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }

    button {
      background: #efefef;
      color: #002666;
      font-weight: bold;
      width: 200px;
      height: 60px;
      border: 0;
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;

        @media (max-width: 768px) {
          width: 140px;
        }
    }
  }
`;

const Categories = styled.div`
  display: flex;
  width: 100%;
  margin-top: 30px;
  margin-left: 10px;

  @media (max-width: 768px) {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
`;

function NavBar() {
  const [search, setSearch] = useState('');
  const searchPath = useSearchPath(search);

  return (
    <Container>
      <Content>
        <form>
          <input
            type="text"
            value={search}
            placeholder="Estou procurando por..."
            onChange={(e) => setSearch(e.target.value)}
          />
          <Link to={searchPath}>
            <Btnsearch type="submit" title="Encontrar" href={searchPath} />
          </Link>
        </form>

        <nav className="navbar- navbar-expand-md" >
          <form>
            <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarMainToggler"
              aria-controls="navbarMainToggler" aria-expanded="false" aria-label="Toggle navigation" style={{ marginTop: "10px" }}>
              Categorias
          </button>
          </form>
          <section className="collapse navbar-collapse" id="navbarMainToggler">
            <Categories>
              {categories.map(({ title, icon, params }) => (
                <CategoryCard href={getPathByParam(params)} title={title} icon={icon} />
              ))}
            </Categories>
          </section>
        </nav>
      </Content>
    </Container>
  );
}

export default NavBar;
